import { useMemo } from 'react';

import { ItineraryServiceRow } from './ItineraryServiceRow';

import type { ItineraryBlock } from '@/types/itinerary';

interface ItineraryServiceProps {
  itineraryBlock: ItineraryBlock;
}

function ItineraryService({ itineraryBlock }: ItineraryServiceProps) {
  const products = useMemo(() => {
    const sortedBlocks = [...itineraryBlock.ItineraryProducts].sort((a, b) => {
      if (a.startDate && b.startDate) {
        const startDateComparison = a.startDate.localeCompare(b.startDate);
        if (startDateComparison !== 0) {
          return startDateComparison;
        }
      }

      if (!a.endDate && !b.endDate) return 0;
      if (!a.endDate) return 1;
      if (!b.endDate) return -1;
      return a.endDate.localeCompare(b.endDate);
    });
    return sortedBlocks;
  }, [itineraryBlock]);

  return (
    <>
      {products.map((product, index) => (
        <ItineraryServiceRow key={product.id} itineraryProduct={product} index={index} blocksLength={products.length} />
      ))}
    </>
  );
}

export { ItineraryService };
